const LOCAL_STORAGE_KEY = "_usr_spid_reg";

export class SPIDRegistrationStatusService {
	getUserRegisteredWithSPID(): boolean {
		return window.localStorage.getItem(LOCAL_STORAGE_KEY) === "true";
	}

	setUserRegisteredWithSPID(value: boolean): void {
		if (value) {
			window.localStorage.setItem(LOCAL_STORAGE_KEY, "true");
		} else {
			window.localStorage.removeItem(LOCAL_STORAGE_KEY);
		}
	}
}
